import { render, staticRenderFns } from "./AmendmentReviewList.vue?vue&type=template&id=5ceefa8c&scoped=true"
import script from "./AmendmentReviewList.vue?vue&type=script&lang=js"
export * from "./AmendmentReviewList.vue?vue&type=script&lang=js"
import style0 from "./AmendmentReviewList.vue?vue&type=style&index=0&id=5ceefa8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ceefa8c",
  null
  
)

export default component.exports